namespace RioERP.Orders {
    export namespace OrderFranchiseeShareCalculationService {
        export const baseUrl = 'Orders/OrderFranchiseeShareCalculation';

        export declare function Create(request: Serenity.SaveRequest<OrderFranchiseeShareCalculationRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<OrderFranchiseeShareCalculationRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<OrderFranchiseeShareCalculationRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<OrderFranchiseeShareCalculationRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "Orders/OrderFranchiseeShareCalculation/Create",
            Update = "Orders/OrderFranchiseeShareCalculation/Update",
            Delete = "Orders/OrderFranchiseeShareCalculation/Delete",
            Retrieve = "Orders/OrderFranchiseeShareCalculation/Retrieve",
            List = "Orders/OrderFranchiseeShareCalculation/List"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List'
        ].forEach(x => {
            (<any>OrderFranchiseeShareCalculationService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
